import { render, staticRenderFns } from "./VehicleProvisionBrigades.vue?vue&type=template&id=f644cdb8&scoped=true&"
import script from "./VehicleProvisionBrigades.vue?vue&type=script&lang=js&"
export * from "./VehicleProvisionBrigades.vue?vue&type=script&lang=js&"
import style0 from "./VehicleProvisionBrigades.vue?vue&type=style&index=0&id=f644cdb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f644cdb8",
  null
  
)

export default component.exports
import {QField,QTable,QTh,QTr,QTd,QBtn,QTooltip,QIcon} from 'quasar'
component.options.components = Object.assign({QField,QTable,QTh,QTr,QTd,QBtn,QTooltip,QIcon}, component.options.components || {})
